// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "maps.proto" (syntax proto3)
// tslint:disable
import { MapService } from "./maps";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service MapService
 */
export class MapServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = MapService.typeName;
        this.methods = MapService.methods;
        this.options = MapService.options;
    }
    /**
     * @generated from protobuf rpc: Geocode
     */
    geocode(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DistanceMatrix
     */
    distanceMatrix(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Elevation
     */
    elevation(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDistanceBetweenPlaces
     */
    getDistanceBetweenPlaces(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: LookupTravelDistance
     */
    lookupTravelDistance(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateTravelDistance
     */
    createTravelDistance(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetTravelDistance
     */
    getTravelDistance(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetTravelDistance
     */
    batchGetTravelDistance(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateTravelDistance
     */
    updateTravelDistance(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
